import React from 'react';
import { Field } from 'redux-form';
import { ReferenceInput, SelectInput } from 'react-admin';
import { required } from 'react-admin';
import Button from '@material-ui/core/Button';
import ContentAdd from '@material-ui/icons/Add';

import DeleteItem from '../../../Common/Partials/DeleteItem';
import RoleTypes from '../../../StaticData/Roles/Types';

const ValidateRequired = required();

type Props = {
  fields: any,
  record: any
};

const PermissionRoles = (props: Props) => (
  <div>
    {props.fields.length > 0 && props.fields.map((permission_role, index) => (
      <div key={index}>
        <div style={{ display: 'flex', width: 400 }}>
          <Field name={`${permission_role}.name`} source={`${permission_role}.name`} resource="teams" component={ReferenceInput} label="Role" reference="helpers/roles" sort={{ field: 'display_name', order: 'ASC' }} filter={{ type: RoleTypes.PERMISSION }} allowEmpty record={props.record}>
            <Field name={`${permission_role}.name`} source={`${permission_role}.name`} component={SelectInput} validate={ValidateRequired} label="" />
          </Field>
          <div style={{ flex: '1', marginTop: 35, paddingLeft: 15 }}>
            <DeleteItem fields={props.fields} index={index} />
          </div>
        </div>
      </div>
    ))}

    <div>
      <Button onClick={() => props.fields.push({ name: '', create: false, delete: false, edit: false, read: false })} color="primary" className="button"><ContentAdd /> Add Role</Button>
    </div>
  </div>
);

export default PermissionRoles;



// WEBPACK FOOTER //
// ./src/views/Components/Teams/Partials/PermissionRoles.tsx